export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11916.b61b8206.jpg";